import {priority} from '@priority-software/priority-proto-api/lib';

export const serializeFields = (
    fields: priority.netitems.nrest.ITreeNode[]
): priority.netitems.nrest.ITreeNode[] => {
    const sortedFields = fields
        .slice()
        .sort((a, b) => a.Title.localeCompare(b.Title))
        .sort((a, b) =>
            a.Type === b.Type
                ? 0
                : a.Type === priority.netitems.nrest.TreeNodeTypes.TreeNodeTypes_Column
                ? -1
                : 1
        );

    const zoomFields = [];
    return sortedFields.reduce((acc, value) => {
        if (acc.find(fld => fld.NodeId === value.NodeId)) {
            return acc;
        }

        if (value.Type === priority.netitems.nrest.TreeNodeTypes.TreeNodeTypes_Column) {
            const FormTitle = !!value.ZoomFormNodeId
                ? fields.find(fld => fld.NodeId === value.ZoomFormNodeId)?.Title
                : '';
            if (!!FormTitle) {
                zoomFields.push(value.ZoomFormNodeId);
            }

            acc.push({...value, FormTitle});
        } else if (!zoomFields.includes(value.NodeId)) {
            acc.push({...value, FormTitle: ''});
        }

        return acc;
    }, [] as priority.netitems.nrest.ITreeNode[]);
};
